import { useMutationState } from "@tanstack/react-query";

import { ANALYSIS_CONFIG_MUTATION_KEY } from "@/api/configuration/useConfigurationAPI";

export type AnalysisConfigHydration = "idle" | "loading" | "error";

export const useAnalysisConfigHydration = (): AnalysisConfigHydration => {
  const statuses = useMutationState({
    filters: {
      mutationKey: ANALYSIS_CONFIG_MUTATION_KEY,
      exact: true,
      predicate: (mutation) => !mutation.state.isPaused
    },
    select: (mutation) => mutation.state.status
  });

  const status = statuses.at(-1);

  if (status === "pending") return "loading";
  if (status === "error") return "error";

  return "idle";
};
